import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import {
  Table,
  Thead,
  Tbody,
  Box,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Button,
  Container,
} from "@chakra-ui/react";

import { UserContext } from "../../../contexts/User";

export default function Clients() {
  const { listClientsApi } = useContext(UserContext);

  const [clients, setClients] = useState();

  async function listClients() {
    try {
      const clients = await listClientsApi();
      setClients(clients.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    listClients();
  }, []);

  return (
    <>
      <Navbar />

      <Container
        position={"absolute"}
        top={120}
        ml={{ base: 0, md: 300 }}
        minWidth={{ base: 0, md: "75vw" }}
      >
        <Flex display={"flex"}>
          <Button>
            <Link to="/adicionar/cliente"> Adicionar novo cliente </Link>
          </Button>
        </Flex>

        <Flex display={"flex"} justifyContent={"center"}>
          <Box mt={"10px"} width={"100%"}>
            <Box>
              <TableContainer>
                <Table variant="striped" colorScheme="teal">
                  <Thead>
                    <Tr>
                      <Th>ID</Th>
                      <Th>Nome</Th>
                      <Th>Email</Th>
                      <Th>Ação</Th>
                    </Tr>
                  </Thead>
                  {clients && (
                    <Tbody>
                      {clients.map((index) => (
                        <Tr key={index.userID}>
                          <Td>{index.userID}</Td>
                          <Td>{index.name}</Td>
                          <Td>{index.email}</Td>
                          <Td>Buttton</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  )}
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Flex>
      </Container>
    </>
  );
}
